import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import styled, { keyframes } from 'styled-components';

export interface SkeletonItemProps {
    height: string;
    width: string;
}

const shimmer = keyframes`
    0% {
        background-position: -300px 0;
    }
    100% {
        background-position: 1000px 0;
    }
`;

export const SkeletonItem = styled.div<SkeletonItemProps>`
    animation-duration: 1.2s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: ${shimmer};
    animation-timing-function: linear;
    background-color: ${token('color.skeleton', colors.N20)};
    background-image: linear-gradient(
        to right,
        ${token('color.skeleton', colors.N20)} 10%,
        ${token('color.skeleton.subtle', colors.N30)} 20%,
        ${token('color.skeleton', colors.N20)} 30%
    );
    background-repeat: no-repeat;
    border-radius: 4px;
    height: ${({ height }) => height};
    width: ${({ width }) => width};
`;
